/*
 * Copyright (c) 2023. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Link } from "react-router-dom";
import React from "react";
import { buttonTextTermsOfServicePrivacyWbsStyles } from "./buttonTextTermsOfServicePrivacyWbsStyles";
import { Box } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";

const ButtonTextTermsOfServicePrivacyWbs = () => {
  return (
    <Box sx={buttonTextTermsOfServicePrivacyWbsStyles.termsOfServiceText}>
      Ich stimme den
      <Link to={"/agb"} target="_blank">
        {" "}
        AGB
      </Link>{" "}
      und dem
      <Link to={"/datenschutz"} target="_blank">
        {" "}
        Datenschutz
      </Link>{" "}
      der Legalbird Rechtsanwälte Rechtsanwalts GmbH und den
      <Link to={"/agb-legalbird"} target="_blank">
        {" "}
        AGB
      </Link>{" "}
      und dem
      <Link to={"/datenschutz-legalbird"} target="_blank">
        {" "}
        Datenschutz
      </Link>{" "}
      von Legalbird zu.
      <br />
      <LockIcon sx={{ height: "12px", width: "12px", paddingTop: "2px" }} /> SSL-zertifiziert - Wir schützen Ihre Daten!
    </Box>
  );
};

export default ButtonTextTermsOfServicePrivacyWbs;
